import { render } from "./BarTu.vue?vue&type=template&id=6e237c88&scoped=true"
import script from "./BarTu.vue?vue&type=script&lang=js"
export * from "./BarTu.vue?vue&type=script&lang=js"

import "./BarTu.vue?vue&type=style&index=0&id=6e237c88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e237c88"

export default script